import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "@playbookai/api-clients";
import { kpiApi } from "../api/live-client.js";
import type { ManagedKpi } from "../api/types.js";
import { kpiKeys } from "./kpiQueryKeys.js";

/** Restore an archived KPI to draft while retaining its target and history. */
export function useRestoreKpi() {
  const config = useApiClient();
  const qc = useQueryClient();
  return useMutation<ManagedKpi, Error, string>({
    mutationFn: (kpiId) => kpiApi.restore(config, kpiId),
    onSuccess: (_data, kpiId) => {
      void qc.invalidateQueries({ queryKey: kpiKeys.lists() });
      void qc.invalidateQueries({ queryKey: kpiKeys.detail(kpiId) });
    },
  });
}
